export * from './google-tag-manager.module';
export * from './google-tag-manager.service';
export * from './google-tag-manager.interfaces';
